import React from 'react';
import {useTranslation} from 'react-i18next';

import {
  LoadingButton,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  showModal,
} from '@edna/components';

import {ModalCenterImage} from 'src/components/primitives';
import {OverlapImage} from 'src/images';

import {showCompanyDetailsModal} from './CompanyDetailsModal';

type TProps = {
  closeModal: TEmptyFunction;
};

const ReminderModal = React.memo<TProps>(({closeModal}) => {
  const {t} = useTranslation();

  const handleClick = React.useCallback(() => {
    closeModal();
    showCompanyDetailsModal(t('CompanyDetails:reminderModal.companyDetails'));
  }, [closeModal, t]);

  return (
    <Modal width="430px">
      <ModalHeader>{t('CompanyDetails:reminderModal.title')}</ModalHeader>
      <ModalContent>{t('CompanyDetails:reminderModal.text')}</ModalContent>
      <ModalCenterImage as={OverlapImage} />
      <ModalActions>
        <LoadingButton
          appearance="primary"
          onClick={handleClick}
          data-selector="CompanyDetails:reminderModal.button"
        >
          {t('CompanyDetails:reminderModal.button')}
        </LoadingButton>
      </ModalActions>
    </Modal>
  );
});

export const showReminderModal = () =>
  showModal((closeModal) => <ReminderModal closeModal={closeModal} />);
